import React from 'react';
import { Calendar } from 'lucide-react';

interface EventCardProps {
  title: string;
  orgName: string;
  date: Date;
}

export const EventCard: React.FC<EventCardProps> = ({ title, orgName, date }) => {
  const safeDate = date instanceof Date && !isNaN(date.getTime()) ? date : new Date();
  const day = safeDate.getDate();
  const month = safeDate.toLocaleString('default', { month: 'short' }).toUpperCase();

  return (
    <div className="flex items-center gap-3 p-3 bg-white border-2 border-black dark:border-white rounded-none hover:border-blue-300 transition-colors cursor-pointer group dark:bg-slate-900">
      <div className="flex flex-col items-center justify-center w-12 h-12 bg-white rounded-none border-2 border-black dark:border-white flex-shrink-0 group-hover:bg-blue-50 transition-colors dark:bg-slate-950">
        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest font-mono leading-none mb-1">
          {month}
        </span>
        <span className="text-lg font-bold text-gray-900 leading-none dark:text-white">
          {day}
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="text-sm font-semibold text-gray-900 truncate mb-0.5 dark:text-white">{title}</h4>
        <div className="flex items-center gap-1 text-[10px] text-gray-500 font-medium uppercase tracking-wider">
          <span className="truncate">{orgName}</span>
        </div>
      </div>
    </div>
  );
};
